import { Alert as AntAlert } from 'antd'
import styled, { css } from 'styled-components'
import { CustomAlertProps } from './Alert'

export const StyledAlert = styled(AntAlert)<CustomAlertProps>`
  ${({ type = 'info' }) => {
    switch (type) {
      case 'info':
        return css`
          .ant-alert-icon {
            color: #1890ff;
          }

          .ant-alert-message,
          .ant-alert-description {
            /* color: #0958d9; */
          }
        `

      case 'success':
        return css`
          background-color: #f6ffed;
          border: 1px solid #b7eb8f;

          .ant-alert-icon {
            color: #52c41a;
          }

          .ant-alert-message,
          .ant-alert-description {
            color: #389e0d;
          }
        `

      case 'warning':
        return css`
          /* background-color: #fffbe6;
          border: 1px solid #ffe58f; */

          .ant-alert-icon.ant-alert-icon {
            /* color: #faad14; */
            margin-right: 0;
          }

          .ant-alert-message.ant-alert-message,
          .ant-alert-description {
            /* color: #d48806; */
          }
        `

      case 'error':
        return css`
          /* background-color: #fff2f0;
          border: 1px solid #ffccc7; */

          .ant-alert-icon {
            color: #ff4d4f;
          }

          .ant-alert-message,
          .ant-alert-description {
            /* color: #d4380d; */
          }
        `

      case 'neutral':
        return css`
          background-color: #fafafa;
          border: 1px solid #d9d9d9;

          .ant-alert-icon {
            color: #8c8c8c;
          }

          .ant-alert-message,
          .ant-alert-description {
            color: #595959;
          }
        `

      case 'light':
        return css`
          background-color: #ffffff;
          border: 1px solid #f0f0f0;

          .ant-alert-icon {
            color: #1890ff;
          }

          .ant-alert-message,
          .ant-alert-description {
            color: #262626;
          }
        `

      case 'dark':
        return css`
          background-color: #262626;
          border: 1px solid #434343;

          .ant-alert-icon {
            color: #ffffff;
          }

          .ant-alert-message,
          .ant-alert-description {
            color: #ffffff;
          }
        `

      case 'bordered':
        return css`
          background-color: #ffffff;
          border: 2px solid #1890ff;

          .ant-alert-icon {
            color: #1890ff;
          }

          .ant-alert-message,
          .ant-alert-description {
            color: #262626;
          }
        `

      default:
        return css``
    }
  }}

  ${({ size = 'medium' }) => {
    switch (size) {
      case 'small':
        return css`
          padding: 8px 12px;
          font-size: 12px;

          .ant-alert-icon {
            font-size: 14px;
            margin-right: 6px;
          }

          .ant-alert-message {
            font-size: 13px;
            margin-bottom: 2px;
          }

          .ant-alert-description {
            font-size: 12px;
            line-height: 1.3;
          }
        `
      case 'medium':
        return css`
          padding: 14px 16px;
          font-size: 14px;

          .ant-alert-icon {
            font-size: 16px;
            margin-right: 8px;
          }

          .ant-alert-message {
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 0;
          }

          .ant-alert-description {
            line-height: 20px;
          }
        `
      case 'large':
        return css`
          padding: 16px 20px;
          font-size: 16px;

          .ant-alert-icon {
            font-size: 18px;
            margin-right: 10px;
          }

          .ant-alert-message {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 6px;
          }

          .ant-alert-description {
            font-size: 14px;
            line-height: 1.5;
          }
        `
      default:
        return css``
    }
  }}

  ${({ rounded }) =>
    rounded &&
    css`
      border-radius: 8px;
    `}

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}
  gap: 8px;

  svg {
    margin-top: 3px;
  }

  .ant-alert-content {
    .ant-alert-message {
      a {
        text-decoration: underline;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  .ant-alert-description {
    a {
      color: inherit;
      text-decoration: underline;
      line-height: 20px;

      &:hover {
        opacity: 0.8;
      }
    }

    ${({ type = 'info', theme }) => {
      switch (type) {
        case 'info':
          return css`
            a {
              color: ${theme.colors.primary};
            }
          `
        case 'success':
          return css`
            a {
              color: #389e0d;
            }
          `
        case 'warning':
          return css`
            a {
              color: #d48806;
            }
          `
        case 'error':
          return css`
            a {
              color: #d4380d;
            }
          `
        default:
          return css`
            a {
              color: #1890ff;
            }
          `
      }
    }}
  }

  .ant-alert-close-icon {
    padding: 0;
    margin-left: 8px;

    .anticon-close {
      font-size: 12px;
      color: #8c8c8c;

      &:hover {
        color: #262626;
      }
    }
  }

  .alert-actions {
    margin-top: 8px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
`
